/** Why a file could not be read as a score. The UI translates the code. */
export type ScoreErrorCode =
  | 'emptyFile'
  | 'malformedXml'
  | 'notMusicXml'
  | 'timewiseNotSupported'
  | 'mxlInvalid'
  | 'mxlNoRootfile'
  | 'mxlTooLarge'
  | 'noParts'
  | 'noNotes';

export class ScoreParseError extends Error {
  readonly code: ScoreErrorCode;
  readonly line: number | null;

  constructor(code: ScoreErrorCode, message: string, line: number | null = null) {
    super(message);
    this.name = 'ScoreParseError';
    this.code = code;
    this.line = line;
  }
}
